<template>
  <div id="footer" class="columns">
    <p class="text">©1989 - {{ this.ano }} - Alterdata Software - Direitos reservados</p>
    <div id="linkAlterdata" class="column is-justify-content-flex-end"></div>
    <a
      id="logo-alterdata-rodape"
      class="hidden-xs logofooter"
      href="http://www.alterdata.com.br"
      target="_blank"
    >
      <img
        id="logo-econtador"
        alt="eContador"
        src="https://cdn.alterdata.com.br/pack/packup/interno/assets/images/alterdata_novo_p.png"
      />
    </a>
  </div>
</template>
<script>
export default {
  name: "TrfFooter",

  data() {
    return { ano: "" };
  },
  methods: {
    buscarAno() {
      var data = new Date();
      this.ano = data.getFullYear();
    },
  },
  mounted() {
    this.buscarAno();
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";
#footer {
  background-color: #929497;
  border-top: 2px solid var(--primaryColor, $primary);
  font-size: 14px;
  text-decoration: none solid rgba(51, 51, 51);
  color: #ffffff;
  height: 62px;
  padding: 10px 15px 0 15px;
  margin: 10px 0 0 -1rem;
  position: absolute;
  bottom: 0;
  width: calc(100% - 3.25rem);
}
.text {
  margin: 5px 0 20px 0;
}
#linkAlterdata {
  margin-top: 10px;
}
@media screen and (max-width: 768px) {
  #footer {
    width: 100%;
    margin-left: -1rem;
  }
}

@media screen and (max-width: 600px) {
   #linkAlterdata, #logo-econtador{
     display: none;
   }
  }

</style>
